import React, { Component, PropTypes } from 'react';
import './missionReport.scss';

function validationErrorMessage(question, cumulativeQuestionNumbers, _) {
  if (question.exception)
    return _("You must report a number");
  if (question.cumulative)
    return _`Sum of questions ${cumulativeQuestionNumbers} must be the same or less than the number of Apprentices in Q1`;
  if (question.number > 1)
    return _("Numbers reported must be the same or less than the total number of Apprentices in Q1");
  return _("Please tell us the total number of Apprentices reporting in Q1")
}

function parseIntOrNull(n) {
  const int = parseInt(n, 10);
  if (isNaN(int)) return null;
  return int;
}

export default class MissionReport extends Component {

  static propTypes = {
    missionReportQuestions: PropTypes.array.isRequired
  };

  static contextTypes = {
    session: PropTypes.object.isRequired,
    setMissionReportAnswer: PropTypes.func.isRequired,
    hideHUD: PropTypes.func.isRequired,
    presenter: PropTypes.bool,
    i18n: PropTypes.func.isRequired
  };

  constructor() {
    super();
    this.state = {
      showValidationErrorModal: false,
      validationErrors: []
    };
  }

  componentWillReceiveProps(nextProps) {
    this.cumulativeQuestionNumbers = (nextProps.missionReportQuestions || []).filter(q => q.cumulative).map(q => q.number);
  }

  componentDidMount() {
    this.refs.question1.focus();
  }

  _getAnswer(questionNumber) {
    const {missionReports, currentLevel} = this.context.session;
    if (!missionReports) return null;
    const levelReport = missionReports[`L${currentLevel}`];
    if (!levelReport) return null;
    const questionAsnwer = levelReport[`Q${questionNumber}`];
    if (!questionAsnwer) return null;
    return parseIntOrNull(questionAsnwer.answer);
  }

  _getCumulativeValue(q1, v1, q2, v2) {
    const { missionReportQuestions } = this.props;
    let cumulativeValue = 0;
    for (const missionReportQuestion of missionReportQuestions) {
      if (!missionReportQuestion.cumulative) continue;
      if (q1 && missionReportQuestion.number === q1.number) {
        cumulativeValue += (v1 || 0);
      } else if (q2 && missionReportQuestion.number === q2.number) {
        cumulativeValue += (v2 || 0);
      } else {
        cumulativeValue += this._getAnswer(missionReportQuestion.number);
      }
    }
    return cumulativeValue;
  }

  _hasValidAnswer(question, answer, nbApprentices, cumulativeValue) {
    if (question.exception || question.number === 1) return answer !== null;
    if (nbApprentices === null || answer === null) return true;
    if (question.cumulative) {
      return cumulativeValue <= nbApprentices;
    }
    return answer <= nbApprentices;
  }

  _setMissionReportQuestion (question, answer, nbApprentices, cumulativeValue) {
    const { session, setMissionReportAnswer, hideHUD } = this.context;
    const { currentLevel: level } = session;
    const isValid = this._hasValidAnswer(question, answer, nbApprentices, cumulativeValue);
    setMissionReportAnswer({
      level,
      questionNumber: question.number,
      question: question.text,
      answer,
      invalid: !isValid
    });
    hideHUD();
  }

  clickHandler (evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  _revalidateOtherQuestions(question1Value, cumulativeValue) {
    const { missionReportQuestions } = this.props;
    missionReportQuestions.forEach((question) => {
      if (question.number === 1) return;
      this._setMissionReportQuestion(question, this._getAnswer(question.number), question1Value, cumulativeValue)
    })
  }

  _revalidateCumulativeQuestions(exceptQ, exceptV, nbApprentices) {
    const { missionReportQuestions } = this.props;
    missionReportQuestions.filter(q => q.cumulative)
      .forEach((question) => {
        if (question.number === exceptQ.number) return;
        const answer = this._getAnswer(question.number);
        const cumulativeValue = this._getCumulativeValue(exceptQ, exceptV, question, answer);
        this._setMissionReportQuestion(question, answer, nbApprentices, cumulativeValue)
      });
  }

  changeHandler (evt) {
    const match = evt.target.name.match(/question(\d+)$/);
    if (match && match[1]) {
      const questionNumber = Number(match[1]);
      const { missionReportQuestions } = this.props;
      const question = missionReportQuestions[questionNumber - 1];
      const value = parseIntOrNull(evt.target.value);
      const nbApprentices = parseIntOrNull(this._getAnswer(1));
      const cumulativeValue = this._getCumulativeValue(question, value);
      if ((value >= 0 && value <= 999) || value === null) {
        this._setMissionReportQuestion(question, value, nbApprentices, cumulativeValue);
      }
      if (questionNumber > 1 && nbApprentices === null) {
        this._setMissionReportQuestion(missionReportQuestions[0], nbApprentices, cumulativeValue)
      }
      if (questionNumber === 1) {
        this._revalidateOtherQuestions(value, cumulativeValue);
      }
      if (question.cumulative) {
        this._revalidateCumulativeQuestions(question, value, nbApprentices);
      }
    }
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  keyDown (evt) {
    const { presenter } = this.context;
    if (evt) {
      if (presenter) {
        // Stop arrow key navigation on teacher remote
        if (evt.keyCode === 37 || evt.keyCode === 39) {  // left, right
          evt.stopPropagation();
          evt.nativeEvent.stopPropagation();
        }
      } else {
        // Don't use arrows for input fields in presentation mode
        if (evt.keyCode === 37 || evt.keyCode === 39) {  // left, right
          evt.preventDefault();
        }
      }
    }
  }


  render () {
    const { missionReportQuestions } = this.props;

    const {
      session: {
        missionReports,
        currentLevel
      }
    } = this.context;

    const answers = missionReports
      ? missionReports[`L${currentLevel}`]
      : null;

    return (
      <div className="mission-report">
        <div className="form-horizontal">
          <div className="form-fields">
            {
              missionReportQuestions.map((question, index) =>
                <div key={index} className="question-group-wrapper">
                <div className={'question-group team-' + (index + 1)}>
                  <label className="control-label">
                    {question.text}
                  </label>
                  <input
                    className="form-control"
                    placeholder=""
                    name={`question${index + 1}`}
                    ref={`question${index + 1}`}
                    type="number"
                    value={
                      answers &&
                      answers[`Q${index + 1}`] &&
                      answers[`Q${index + 1}`].answer
                    }
                    min={0}
                    max={999}
                    onClick={::this.clickHandler}
                    onChange={::this.changeHandler}
                    onKeyDown={::this.keyDown}
                  />
                </div>
                <div className="question-group-error">
                  {answers && answers[`Q${index + 1}`] && answers[`Q${index + 1}`].invalid && validationErrorMessage(question, this.cumulativeQuestionNumbers, this.context.i18n)}
                </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/session/presentation/components/missionReport.js